import React from 'react';
import ReactDOM from 'react-dom';


import registerServiceWorker from 'registerServiceWorker';
import startup from 'helpers/startup';
import App from 'ui/App';

import 'css/reset.css';
import 'css/color.css';
import 'css/display.css';
import 'css/border.css';
import 'css/layout.css';
import 'css/type.css';
import 'css/animation.css';
import 'css/index.css';



startup();


// Render app, hydrating static render if able.
const rootEl = document.getElementById('root');

if (rootEl.hasChildNodes()) {
	ReactDOM.hydrate(
		React.createElement(App),
		rootEl
	);
} else {
	ReactDOM.render(
		React.createElement(App),
		rootEl
	);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js